export const examInstructions = [
    {
        instructionNumber: "1",
        instructionTitle: "Instructions",
        instructionText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae. Eget aliquet nibh praesent tristique magna. Vulputate mi sit amet mauris commodo quis. Mattis ullamcorper velit sed ullamcorper morbi tincidunt ornare massa. Nulla pharetra diam sit amet nisl. Nec ultrices dui sapien eget mi proin sed libero enim. Congue eu consequat ac felis donec et.Morbi non arcu risus quis varius quam quisque id diam. Et pharetra pharetra massa massa ultricies mi quis. Ultricies leo integer malesuada nunc vel. A diam maecenas sed enim ut sem viverra aliquet. Non blandit massa enim nec. Sollicitudin tempor id eu nisl nunc. Massa id neque aliquam vestibulum morbi blandit cursus. Viverra maecenas accumsan lacus vel facilisis volutpat est velit.",
    },
    {
        instructionNumber: "2",
        instructionTitle: "Rules",
        instructionText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae.Eget aliquet nibh praesent tristique magna. Vulputate mi sit amet mauris commodo quis. Mattis ullamcorper velit sed ullamcorper morbi tincidunt ornare massa. Nulla pharetra diam sit amet nisl. Nec ultrices dui sapien eget mi proin sed libero enim. Congue eu consequat ac felis donec et.Morbi non arcu risus quis varius quam quisque id diam. Et pharetra pharetra massa massa ultricies mi quis. Ultricies leo integer malesuada nunc vel. A diam maecenas sed enim ut sem viverra aliquet. Non blandit massa enim nec. Sollicitudin tempor id eu nisl nunc. Massa id neque aliquam vestibulum morbi blandit cursus. Viverra maecenas accumsan lacus vel facilisis volutpat est velit.",
    },
]

export const examQuestions = [
    {
        questionNumber: "1",
        questionText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae. ",
        questionOptions: [
            {
                optionText: "Lorem ipsum",
            },
            {
                optionText: "Lorem ipsum dolor sit",

            },
            {
                optionText: "Lorem ipsum dolor",

            },
            {
                optionText: "Lorem ipsum dolor",

            },
            {
                optionText: "Lorem ipsum",

            },
        ]
    },
    {
        questionNumber: "2",
        questionText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae. ",
        questionOptions: [
            {
                optionText: "Lorem ipsum",

            },
            {
                optionText: "Lorem ipsum dolor sit",

            },
            {
                optionText: "Lorem ipsum dolor",
            },
            {
                optionText: "Lorem ipsum dolor",
            },
            {
                optionText: "Lorem ipsum",

            },
        ]
    },
    {
        questionNumber: "3",
        questionText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae. ",
        questionOptions: [
            {
                optionText: "Lorem ipsum",

            },
            {
                optionText: "Lorem ipsum dolor sit",
            },
            {
                optionText: "Lorem ipsum dolor",

            },
            {
                optionText: "Lorem ipsum dolor",

            },
            {
                optionText: "Lorem ipsum",
            },
        ]
    },
    {
        questionNumber: "4",
        questionText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae. ",
        questionOptions: [
            {
                optionText: "Lorem ipsum",

            },
            {
                optionText: "Lorem ipsum dolor sit",

            },
            {
                optionText: "Lorem ipsum dolor",
            },
            {
                optionText: "Lorem ipsum dolor",

            },
            {
                optionText: "Lorem ipsum",

            },
        ]
    },
    {
        questionNumber: "5",
        questionText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae. ",
        questionOptions: [
            {
                optionText: "Lorem ipsum",

            },
            {
                optionText: "Lorem ipsum dolor sit",

            },
            {
                optionText: "Lorem ipsum dolor",
            },
            {
                optionText: "Lorem ipsum dolor",
            },
            {
                optionText: "Lorem ipsum",

            },
        ]
    },
    {
        questionNumber: "6",
        questionText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae. ",
        questionOptions: [
            {
                optionText: "Lorem ipsum",

            },
            {
                optionText: "Lorem ipsum dolor sit",

            },
            {
                optionText: "Lorem ipsum dolor",
            },
            {
                optionText: "Lorem ipsum dolor",
            },
            {
                optionText: "Lorem ipsum",

            },
        ]
    },
    {
        questionNumber: "7",
        questionText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae. ",
        questionOptions: [
            {
                optionText: "Lorem ipsum",

            },
            {
                optionText: "Lorem ipsum dolor sit",

            },
            {
                optionText: "Lorem ipsum dolor",
            },
            {
                optionText: "Lorem ipsum dolor",
            },
            {
                optionText: "Lorem ipsum",

            },
        ]
    },
    {
        questionNumber: "8",
        questionText: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae. ",
        questionOptions: [
            {
                optionText: "Lorem ipsum",

            },
            {
                optionText: "Lorem ipsum dolor sit",

            },
            {
                optionText: "Lorem ipsum dolor",
            },
            {
                optionText: "Lorem ipsum dolor",
            },
            {
                optionText: "Lorem ipsum",

            },
        ]
    }
]